const People = () => import("Core/people/views/People");
const PeopleForm = () => import("Core/people/views/PeopleForm");
const PeopleProfile = () => import("Core/people/views/Profile");

export default {
    children: [
        {
            path: "people",
            name: "people",
            component: People,
            meta: {
                requiresAuth: true,
                title: "lang.people",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: ["people.read"],
            },
        },
        {
            path: "people/profile/:id?/:tab?",
            name: "person",
            component: PeopleProfile,
            meta: {
                requiresAuth: true,
                title: "lang.people",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: ["people.read"],
            },
        },
    ],
};
